export default "__VITE_ASSET__DT_B9TJX__"